// src/views/auth/Auth.js
import React, { useState } from "react";
import { auth, database } from "../../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { ref, push } from "firebase/database";
import emailLogo from "../../assets/email-logo.png";
import "./Auth.css";

const Auth = ({ onSignIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [failedAttempts, setFailedAttempts] = useState(0);
  const [totalFailedAttempts, setTotalFailedAttempts] = useState(0);

  const handleSignInWithEmail = () => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        setError("");
        setFailedAttempts(0);
        onSignIn(userCredential.user);
      })
      .catch(() => {
        setError("Invalid credentials. Please try again.");
        handleFailedAttempt(email);
      });
  };

const handleFailedAttempt = (userEmail) => {
  setFailedAttempts((prevFailed) => {
    const newFailed = prevFailed + 1;
    setTotalFailedAttempts((prevTotal) => {
      const newTotal = prevTotal + 1;

      if (newTotal % 3 === 0) {
        // Send alert on every 3rd total failed attempt
        const alertRef = ref(database, "alerts/failedLogins");
        const alertData = {
          email: userEmail,
          timestamp: new Date().toISOString(),
          message: `User has failed to log in ${newTotal} times.`,
        };

        push(alertRef, alertData)
          .then(() => console.log("Alert sent to Firebase successfully."))
          .catch((error) =>
            console.error("Error sending alert to Firebase:", error)
          );
      }

      return newTotal;
    });

    // Reset failedAttempts every 3 local tries
    if (newFailed >= 3) return 0;
    return newFailed;
  });
};


  return (
    <div className="auth-container">
      <h2>Sign In</h2>

      <div className="auth-field">
        <label htmlFor="auth_email">Email</label>
        <input
          id="auth_email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="auth-field">
        <label htmlFor="auth_password">Password</label>
        <input
          id="auth_password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <button
        className="email-sign-in"
        onClick={handleSignInWithEmail}
        disabled={!email || !password}
      >
        <img src={emailLogo} alt="Email Icon" className="email-logo" />
        Sign in with Email
      </button>

      {error && <div className="auth-error">{error}</div>}
    </div>
  );
};

export default Auth;
